import { FallbackProps } from 'react-error-boundary';
import { Footer, Header } from '@/components';

export const ErrorHandler = (props: FallbackProps) => {
  const { error, resetErrorBoundary } = props;
  return (
    <div>
      <Header isGlobalHeader isForSearchApplication />
      <div className="error-page flex min-h-[50vh] items-center justify-center">
        <div className="text-center">
          <h1 className="text-red- mb-4 text-5xl font-semibold">Errors</h1>
          <p className="text-grey-800 text-2xl font-semibold">{error.message}</p>
          <div className="mt-4">
            Please reload page or click{' '}
            <a
              href="/"
              className="font-bold"
              onClick={(e) => {
                e.preventDefault();
                resetErrorBoundary();
                window.location.href = '/';
              }}
            >
              here
            </a>{' '}
            to go back to the search home page.
          </div>
        </div>
      </div>
      <Footer isFullFooter />
    </div>
  );
};
